import React from 'react'
import './index.css'

import {Input, Button, Form, message} from 'antd';

import {connect} from "react-redux"

import * as actionCreators from '../../store/actionCreators'

import axios from 'axios'
import HomeHearder from '../Pages/Home/NewHome/HomeHearder'

import {CSSTransition} from 'react-transition-group';

const baseUrl = "/yunguanAvatar/user/";

class ResetPwd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            curPage: 0,
            timeLeft: 5,
            question1: "",
            question2: "",
        };
        this.resetFormDate = {};
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            if (this.state.curPage === 3 && this.state.timeLeft > 0) {
                this.setState({timeLeft: this.state.timeLeft - 1});
            } else if (this.state.curPage === 3 && this.state.timeLeft === 0) {
                this.props.history.push({pathname: '/Home', state: {}});
            }
        }, 1000);
    }


    componentWillUnmount() {
        clearInterval(this.interval);
    }

    subMitEmail = async (data) => {
        const {data: res} = await axios.get(baseUrl + `findQuestion?username=${data.registerEmail}`);
        let localeDate = res.data;
        if (res.code === 1) {
            this.setState({question1: localeDate.question1, question2: localeDate.question2});
            this.resetFormDate["username"] = data.registerEmail;
            this.resetFormDate["question1"] = localeDate.question1;
            this.resetFormDate["question2"] = localeDate.question2;
            this.handlesNextPage();
        } else if (res.code === 0) {
            // 该用户不存在弹窗
            message.error("用户不存在，请检查邮箱输入是否正确！");
        }
    }

    subMitAnswer1 = (data) => {
        this.resetFormDate["answer1"] = data.answer1;
        this.handlesNextPage();
    }

    subMitAnswer2 = async (data) => {

        this.resetFormDate["answer2"] = data.answer2

        await axios.post(
            baseUrl + "findPwd",
            this.resetFormDate,
            {
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        ).then(
            (res) => {
                if (res.data.code === 1) {
                    message.info("正在发送邮件，请稍等...", 1);
                    this.handlesNextPage();
                } else if (res.data.code === -1003) {
                    message.error("注册问题1回答不正确")
                } else if (res.data.code === -1004) {
                    message.error("注册问题2回答不正确")
                }
            }
        );

    }


    buildPage = () => {
        const pageContent = [
            <Form
                className='change_part'
                onFinish={this.subMitEmail}
            >
                <div className='prompt_font'>请填写您的注册邮箱</div>
                <Form.Item
                    name='registerEmail'
                    rules={[
                        {required: true, message: '请输入您的注册邮箱!'},
                        () => ({
                            validator(_, value) {
                                let rule3 = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                                if (!value || rule3.test(value)) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('邮箱格式不正确!'));
                            },
                        }),
                    ]}
                >
                    <Input className='input_style' placeholder='注册邮箱'
                    />
                </Form.Item>
                <Button className='button_style' type="primary" htmlType='submit'
                        onBlur={(e) => e.target.blur()}>下一步</Button>
            </Form>,
            <Form className='change_part'
                  onFinish={this.subMitAnswer1}
            >
                <div className='prompt_font'>请回答您的注册问题</div>
                <div className='question_font'>{this.state.question1}</div>
                <Form.Item
                    name='answer1'
                    rules={[{required: true, message: '请输入您的回答!'}]}
                >
                    <Input className='input_style' placeholder='请输入您的回答'
                    />
                </Form.Item>
                <Button className='button_style' type="primary" htmlType='submit'>下一步</Button>
                <Button className='back_font' type="text" onClick={this.handlesPrePage}>返回</Button>
            </Form>,
            <Form className='change_part'
                  onFinish={this.subMitAnswer2}
            >
                <div className='prompt_font'>请回答您的注册问题</div>
                <div className='question_font'>{this.state.question2}</div>
                <Form.Item
                    rules={[{required: true, message: '请输入您的回答!'}]}
                    name='answer2'
                >
                    <Input className='input_style' placeholder='请输入您的回答'
                    ></Input>
                </Form.Item>
                <Button className='button_style' type="primary" htmlType='submit'>下一步</Button>
                <Button className='back_font' type="text" onClick={this.handlesPrePage}>返回</Button>
            </Form>,
            <div className='change_part'>
                <div className='success_font'>您已成功修改密码，{this.state.timeLeft}秒后跳转至首页</div>
            </div>
        ];
        let curPage = this.state.curPage <= pageContent.length - 1 ? this.state.curPage : pageContent.length - 1;
        return (
            <CSSTransition
                in={true}
                timeout={1000}
                classNames="page"
                unmountOnExit
            >
                {pageContent[curPage]}
            </CSSTransition>
        );
    }


    handlesNextPage = () => {
        this.setState({curPage: this.state.curPage + 1});
    }

    handlesPrePage = () => {
        this.setState({curPage: this.state.curPage - 1});
    }

    render() {
        return (
            <>
                <div className="user-reset-bg">
                    <HomeHearder/>
                    <div className='user_reset_panel'>
                        <form className='user_reset_content'>
                            <div className='user_reset_title'>找回密码</div>
                            {this.buildPage()}
                        </form>
                    </div>
                </div>
            </>
        );
    }
}


const mapState = (state) => ({})

const mapDispatch = (dispatch) => ({
    saveUserName: (param) => dispatch(actionCreators.saveUserName(param)),
    saveQuestionOne: (param) => dispatch(actionCreators.saveQuestionOne(param)),
    saveQuestionTwo: (param) => dispatch(actionCreators.saveQuestionTwo(param))
})
export default connect(mapState, mapDispatch)(ResetPwd)


// 用户自定义密码界面，需要时取用

//        case 3:
// return (
//   <Form className='change_part'
//     onFinish={this.subMitNewPassword}
//   >
//     <div className='prompt_font'>修改您的密码</div>
//     <Form.Item
//       name='newPassword'
//       rules={[
//         { required: true, message: '请输入新密码!(密码必须是3~16字符，含字母数字)' },
//         () => ({
//           validator(_, value) {
//             if (!value || /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{3,16}$/.test(value)) {
//               return Promise.resolve();
//             }
//             return Promise.reject(new Error('密码必须是3~16字符，含字母数字!'));
//           },
//         })
//       ]}

//     >
//       <Input.Password className='input_style' placeholder='请输入新密码(3~16字符，含字母数字)'  ></Input.Password>
//     </Form.Item>
//     <div className='prompt_font'>确认您的密码</div>
//     <Form.Item
//       name='confirmPassword'
//       rules={[
//         { required: true, message: '请再次输入确认新密码!' },
//         ({ getFieldValue }) => ({
//           validator(_, value) {
//             if (!value || getFieldValue('newPassword') === value) {
//               return Promise.resolve();
//             }
//             return Promise.reject(new Error('两次密码输入不一致!'));
//           },
//         }),

//       ]}
//     >
//       <Input.Password className='input_style' placeholder='请再次输入确认新密码'  ></Input.Password>
//     </Form.Item>
//     <Button className='button_style' type="primary" htmlType='submit'>确认</Button>
//   </Form>
// );
